// extracted by mini-css-extract-plugin
export var gif = "_ja-0";